
const isLoggingEnabled = true;

export const logger = {
  log: (...args) => {
    if (isLoggingEnabled) {
      console.log(...args);
    }
  },
  error: (...args) => {
    if (isLoggingEnabled) {
      console.error(...args);
    }
  },
  warn: (...args) => {
    if (isLoggingEnabled) {
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (isLoggingEnabled) {
      console.info(...args);
    }
  },
};
